import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-left-sidebar-subitem',
  templateUrl: './left-sidebar-subitem.component.html',
  styleUrls: ['./left-sidebar-subitem.component.scss']
})
export class LeftSidebarSubitemComponent {

  constructor() {}

  @Input() _isGridMode:boolean;
  @Input() parentItem;
  @Output() updateCurrentTool: EventEmitter<any> = new EventEmitter<any>();
  @Output() onElementMouseDown: EventEmitter<any> = new EventEmitter<any>();

  public openCategoryList = [];

  preventDefault(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  addToolTooltip($event){
    this.onElementMouseDown.emit($event);
  }

  toggleCategoryOpen(category){
    if (this.openCategoryList.indexOf(category.category.id) >= 0){
      this.openCategoryList.splice(this.openCategoryList.indexOf(category.category.id), 1)
    }
    else{
      this.openCategoryList.push(category.category.id)
    }
    // this.cd.detectChanges()
  }

  isOpenedCategory(category){
    return this.openCategoryList.includes(category.category.id);
  }

  setCurrentTool(tool){
    this.updateCurrentTool.emit(tool);
  }

  getHint(item) {
    return ((item.hint && item.hint.length) ? item.hint : '');
  }

  isCategory(item) {
    return item && item.hasOwnProperty('items');
  };

  getName(item) {
    if (this.isCategory(item)) {
      return item.category.name;
    }
    return item.name;
  };

  getCategoryOrItemId(item): number {
    if (this.isCategory(item)) {
      return item.category.id;
    }
    return item.id;
  }

  getMenuIcon(item) {
    if (this.isCategory(item)) {
      return item.category.menu_icon;
    }
    return item.menu_icon;
  };

  hasMenuIcon(item) {
    return (this.getMenuIcon(item) && this.getMenuIcon(item).length > 0);
  };

  isGridMode(){
    return this._isGridMode;
  }

  getItems(item){
    if (item){
      return item.items;
    }
    return null;
  }
}
